import { Model } from '../parents/model';

export class AttachmentModel extends Model {
  static ATTR_NAME = 'name'; // should be url-safe (max 100 chars)
  static ATTR_EXTENSION = 'extension'; // based on MIME type
  static ATTR_MIME_TYPE = 'mime_type';
  static ATTR_SIZE = 'size'; // in bytes
  /*
   * STATUS VALUES:
   * 'created' - before the file is uploaded
   * 'uploaded' - after the file is completely uploaded
   * 'in_use' - when the file is used by an entity
   */
  static ATTR_STATUS = 'status';
  static ATTR_DOWNLOAD_URL = 'download_url'; // only available when status is 'uploaded', expires after 1 day
  static ATTR_CREATED_AT = 'created_at';

  get name() {
    return this.attributes[AttachmentModel.ATTR_NAME];
  }

  get extension() {
    return this.attributes[AttachmentModel.ATTR_EXTENSION];
  }

  get mimeType() {
    return this.attributes[AttachmentModel.ATTR_MIME_TYPE];
  }

  get size() {
    return this.attributes[AttachmentModel.ATTR_SIZE];
  }

  get status() {
    return this.attributes[AttachmentModel.ATTR_STATUS];
  }

  get downloadUrl() {
    return this.attributes[AttachmentModel.ATTR_DOWNLOAD_URL];
  }

  get createdAt() {
    return this.attributes[AttachmentModel.ATTR_CREATED_AT];
  }
}
